import * as React from "react";
const SvgComponent = ({ strokeColor = "#90EE90", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="Layer_1"
    x={0}
    y={0}
    height="100%"
    width="100%"
    style={{
      enableBackground: "new 0 0 104.2 65.7",
    }}
    viewBox="0 0 104.2 65.7"
    {...props}
  >
    <style type="text/css">
      {
        `.st0{fill:none;stroke:${strokeColor};stroke-miterlimit:10;}
        .st1{fill:none;stroke:${strokeColor};stroke-width:1;stroke-miterlimit:9.9964;}
        .st2{fill:none;stroke:${strokeColor};stroke-miterlimit:9.9989;}
        .st3{fill:none;stroke:${strokeColor};stroke-width:0.77;stroke-miterlimit:10;}`
      }
    </style>
    <g id="Layer_2_00000065762999534967052760000011545545492183115412_">
      <g id="Layer_3_00000134222534219151621430000015566690309026192564_">
        <path
          className="st0"
          d="M51.6,57.1c-1.1-5.7-1.3-12-3.5-15.5c-4.2-7.3-13.3-6.2-11.6,8.1"
        />
        <line className="st0" x1={12.1} y1={40.8} x2={36.5} y2={49.7} />
        <path
          className="st0"
          d="M2,22.5c2.1-3.7,1.3-3.6,4.1-4.2c0.1,0,0.1,0,1.4-0.7"
        />
        <path className="st0" d="M39.8,36.3c2.6-0.9,7.8,0.3,8.9,3.8" />
        <path className="st0" d="M39.9,36.3c-4.8,2-4.8,10-3.6,13.3" />
        <line className="st0" x1={9.7} y1={37.2} x2={35.9} y2={46.6} />
        <line className="st0" x1={47.1} y1={40.2} x2={58.5} y2={41.3} />
        <path className="st0" d="M2.1,22.3c-0.8,3.4-1.1,9.4,0.4,10" />
        <path className="st0" d="M5.7,22.7c-3.7-0.4-5.1,2.5-3.9,7.1" />
        <path className="st0" d="M5.8,24.1c-3.6,0.1-3.7,4.3-3.6,8.1" />
        <path className="st0" d="M12.2,38.1c-0.7-2.1-1.3-15-6.5-14" />
        <path className="st0" d="M36.7,49.4c-0.5,2.3,0,4.2,0.2,4.2" />
        <path className="st0" d="M60.7,58.6c-3-0.8-5.9-1.6-9.6-1.9" />
        <path className="st0" d="M73.5,45.5c-0.6,0.8-11.1,0.7-21.9-2.1" />
        <path className="st0" d="M102.7,35.3c0.6,0,0.5,8-1.7,9" />
        <path className="st0" d="M101.3,44c1.1,1.8-0.9,3.8-2.8,3.9" />
        <line className="st0" x1={99.3} y1={47.7} x2={63.7} y2={58.6} />
        <path className="st0" d="M60.5,58.5c0.5,0.1,2.6,0.3,3.4,0" />
        <path className="st0" d="M98.2,19.5c2.1,5,2.1,11,1.7,13.3" />
        <path className="st0" d="M102.6,35.1c0,0.6-1.5,1-3.2,0.9" />
        <path className="st0" d="M99.8,32.5c0,0,1.6,2.1,2.9,2.8" />
        <path className="st0" d="M102.7,35.1c-0.1,1.9-2.1,3.4-4,3.3" />
        <path className="st0" d="M47.3,40.5c0,0-4.1-0.1-4.4,0.9" />
        <path className="st0" d="M54.5,57.1c-0.4,4.2-2.3,7.3-3.4,7.4" />
        <path className="st0" d="M44.3,64.9c1,0,1.7,0.3,6.9-0.4" />
        <path className="st0" d="M5.5,26.4c0.4-0.7,1.8-0.8,3.2-0.7" />
        <path className="st0" d="M12.9,38.2c-0.3,2.8-1.9,4.2-2,4" />
        <path className="st0" d="M6.5,41.7c0.1,0.1,2.9,0.6,4.5,0.5" />
        <path className="st0" d="M9.6,36.3c2.5,1.8,3,1.6,2.9,2.1" />
        <g id="Layer_2_00000008850815465066213290000017902465927333571458_">
          <ellipse
            transform="matrix(0.9992 -3.939623e-02 3.939623e-02 0.9992 -2.0622 1.7435)"
            className="st1"
            cx={43.2}
            cy={53.2}
            rx={6.1}
            ry={11.8}
          />
          <path
            className="st0"
            d="M47.7,53c0.2,4.8-1.7,8.8-4.3,8.9c-2.5,0.1-4.7-3.6-5-8.6c-0.2-4.8,1.7-8.8,4.3-8.9 C45.4,44.3,47.6,48.2,47.7,53z"
          />
        </g>
        <g id="Layer_2_00000098189277519965804350000001933119724015553702_">
          <path
            className="st2"
            d="M9.9,34c-0.2-4.2-2.4-7.6-4.4-7.5c-2.1,0-3,3.4-2.9,7.7s1.9,7.7,3.9,7.6C8.5,41.8,10.1,38.3,9.9,34z"
          />
          <path
            className="st0"
            d="M8.2,34c0.2,3.4-0.7,5.9-1.9,5.9C5.1,40,4,37.4,3.8,34.2c-0.2-3.4,0.7-5.9,1.9-5.9C7,28.1,8.1,30.7,8.2,34z"
          />
        </g>
      </g>
    </g>
    <ellipse className="st3" cx={5.9} cy={34.1} rx={0.5} ry={1} />
    <ellipse className="st0" cx={43.2} cy={53.3} rx={0.8} ry={1.8} />
    <line className="st0" x1={43.2} y1={55.1} x2={43.2} y2={61.6} />
    <line className="st0" x1={43.1} y1={44.4} x2={43.2} y2={51.5} />
    <line className="st0" x1={43.9} y1={53.3} x2={47.7} y2={53.3} />
    <line className="st0" x1={42.4} y1={53.3} x2={38.4} y2={53.3} />
    <line className="st0" x1={39.1} y1={48} x2={42.5} y2={52.4} />
    <line className="st0" x1={43.9} y1={54.5} x2={47.1} y2={58} />
    <line className="st0" x1={46.7} y1={48} x2={43.9} y2={52.2} />
    <line className="st0" x1={42.4} y1={54.5} x2={39.5} y2={58.4} />
    <line className="st0" x1={5.9} y1={28.6} x2={5.8} y2={32.9} />
    <line className="st0" x1={5.9} y1={35.2} x2={5.9} y2={39.7} />
    <line className="st0" x1={5.3} y1={34.1} x2={4} y2={34.1} />
    <line className="st0" x1={6.7} y1={34.1} x2={8.2} y2={34} />
    <line className="st0" x1={6.4} y1={34.8} x2={7.8} y2={37} />
    <line className="st0" x1={4.1} y1={31.8} x2={5.4} y2={33.6} />
    <line className="st0" x1={7.6} y1={31.1} x2={6.3} y2={33.4} />
    <line className="st0" x1={5.3} y1={34.7} x2={4.2} y2={36.8} />
  </svg>
);
export default SvgComponent;
